/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
interface GetIntegrationSectionVariantProps {
  isIntegrationsShown?: boolean;
  isSaleVehicle: boolean;
  isServiceVehicle: boolean;
  canReadBusinessCase: boolean;
  isWorkshopModuleEnabled: boolean;
}

interface GetIsIntegrationSectionEmptyProps {
  variant: IntegrationSectionVariant;
  canReadPriceReportWidget: boolean;
  canShowCarPassWidget: boolean;
  canShowCarVerticalWidget: boolean;
  canShowCebiaAutotracerWidget: boolean;
  canShowCebiaReportWidget: boolean;
  canShowCebiaRokvyWidget: boolean;
  canShowVehicleHistoryReportWidget: boolean;
  canShowMiraPredictionWidget: boolean;
}

export type IntegrationSectionVariant = 'hidden' | 'sale' | 'service';

export const getIntegrationSectionVariant = (
  props: GetIntegrationSectionVariantProps
): IntegrationSectionVariant => {
  if (!props.isIntegrationsShown) {
    return 'hidden';
  }

  if (props.isSaleVehicle && props.canReadBusinessCase) {
    return 'sale';
  }

  if (props.isServiceVehicle && props.isWorkshopModuleEnabled) {
    return 'service';
  }

  return 'hidden';
};

export const getIsIntegrationSectionEmpty = (props: GetIsIntegrationSectionEmptyProps): boolean => {
  if (props.variant === 'hidden') {
    return true;
  }

  if (props.variant === 'service') {
    return (
      !props.canShowCebiaAutotracerWidget &&
      !props.canShowMiraPredictionWidget &&
      !props.canShowVehicleHistoryReportWidget
    );
  }

  return (
    !props.canReadPriceReportWidget &&
    !props.canShowCarPassWidget &&
    !props.canShowCarVerticalWidget &&
    !props.canShowCebiaAutotracerWidget &&
    !props.canShowCebiaReportWidget &&
    !props.canShowCebiaRokvyWidget &&
    !props.canShowVehicleHistoryReportWidget &&
    !props.canShowMiraPredictionWidget
  );
};
